import React from "react";
import KOGTextEllipsis from "@components/shared/kogTextEllipsis/kogTextEllipsis";

import * as S from "./styles";
import { GridFileResponse } from "@/main/components/shared/fileGrid/cardFileGrid";
import KOGPreviewFile from "@/main/components/shared/kogPreviewFile/kogPreviewFile";
import { QuoteImageResponse } from "@/main/models/response";
import { IconButton, Tooltip } from "@mui/material";
import { getTranslateByKey } from "@/main/services/utils";
import GetApp from "@mui/icons-material/GetApp";
import * as CardFileGridStyles from "../../styles";

interface ICardFileCarouselProps {
	file: GridFileResponse;
	canDownload?: boolean;
	handleDownload?: (imageUrl: string, imageRecord: QuoteImageResponse) => Promise<void>;
	fileRecord?: QuoteImageResponse;
	fileDetails?: React.ReactNode;
}

function CardFileCarousel({
	file,
	canDownload,
	handleDownload,
	fileRecord,
	fileDetails,
}: Readonly<ICardFileCarouselProps>) {
	const classes = CardFileGridStyles.useStyles();

	return (
		<S.Container>
			<S.HeaderFile canDownload={canDownload}>
				<S.TitleFile>
					<KOGTextEllipsis text={file.fileName} type="file" />
				</S.TitleFile>
				{canDownload && fileRecord && (
					<Tooltip title={getTranslateByKey("information.downloadFile")}>
						<IconButton
							className={classes.buttonBaseDeletePreview}
							id={`id-${file.fileName}-btn-download-${file.guid}`}
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								if (handleDownload) {
									handleDownload(file.fileUrl, fileRecord);
								}
							}}
						>
							<GetApp fontSize="small" />
						</IconButton>
					</Tooltip>
				)}
			</S.HeaderFile>
			{fileDetails && <S.FileDetails>{fileDetails}</S.FileDetails>}
			<S.PreviewFile>
				<KOGPreviewFile fileUrl={file.fileUrl} fileExtension={file.fileExtension} guidFile={file.guid} />
			</S.PreviewFile>
		</S.Container>
	);
}

export default CardFileCarousel;
